import { Component, OnInit, ViewChild } from "@angular/core";
import { ColumnTypes } from "src/app/shared/Models/enums/ColumnTypeEnum";
import { FilterableTableComponent } from "src/app/shared/table/filterable-table.component";
import { ToastService } from "src/app/shared/toast.service";
import { DeviceCheckService } from "../../survey/shared/services/device-check.service";
import { BulkConfigurationSettingDto } from "../models/BulkConfigurationSettingDto";
import { Table } from "primeng/table";
import { first } from "rxjs/operators";
import { NavAction } from "src/app/shared/top-nav/top-nav.component";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";
import { Router } from "@angular/router";
import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";
import { BulkConfigurationType } from "../models/BulkConfigurationType.enum";
import { BulkConfigurationService } from "../services/bulk-configuration.service";
import { BulkService } from "../services/bulk.service";
import { BulkConfigurationDto } from "../models/BulkConfigurationDto";

@Component({
  selector: "app-admin-bulk-configuration",
  templateUrl: "./admin-panel-bulk-configuration.component.html",
  styleUrls: ["./admin-panel-bulk-configuration.component.scss"],
})
export class AdminPanelBulkConfigurationComponent
  extends FilterableTableComponent<BulkConfigurationDto>
  implements OnInit
{
  @ViewChild("dt") dataTable: Table;

  navActions: NavAction[] = [];
  saveStates = SaveStateTypeEnum;

  scrollOffsetLandscape: number = 245;
  scrollOffsetPortrait: number = 245;

  allCols = [
    {
      field: "bulkConfigurationTypeName",
      header: "BULK CONFIGURATION TYPE",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "displayName",
      header: "DESCRIPTION",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "commandType",
      header: "COMMAND TYPE",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "fileNamePrefix",
      header: "FILENAME PREFIX",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "partnerAccessAllowed",
      header: "PARTNER ACCESS ALLOWED",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.BOOLEAN,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
  ];

  constructor(
    private _router: Router,
    private _toastService: ToastService,
    private _bulkService: BulkService,
    private _bulkConfigurationService: BulkConfigurationService,
    private _deviceCheckService: DeviceCheckService,
    private _permissionsService: PermissionsService
  ) {
    super(_toastService, _deviceCheckService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getBulkConfigurations();
    this.navActions = this.initNavActions();
  }

  changeBulkConfigurationSetting(
    bulkConfigurationSetting: BulkConfigurationDto
  ) {
    bulkConfigurationSetting.state = SaveStateTypeEnum.ongoing;

    var updatedSetting = new BulkConfigurationSettingDto();
    updatedSetting.partnerAccessAllowed =
      bulkConfigurationSetting.partnerAccessAllowed;
    updatedSetting.type = bulkConfigurationSetting.bulkConfigurationType;

    this._bulkConfigurationService
      .changeBulkConfigurationSetting(updatedSetting)
      .subscribe(
        (res: any) => {
          bulkConfigurationSetting.state = SaveStateTypeEnum.done;
          setTimeout(() => {
            bulkConfigurationSetting.state = SaveStateTypeEnum.unkown;
          }, 5000);
        },
        (err) => {
          // When there is an error, change the value to the previous value
          bulkConfigurationSetting.partnerAccessAllowed =
            !bulkConfigurationSetting.partnerAccessAllowed;
          bulkConfigurationSetting.state = SaveStateTypeEnum.failed;
        }
      );
  }

  canShowStateInfo(bulkConfiguration: BulkConfigurationDto): boolean {
    return (
      bulkConfiguration &&
      (bulkConfiguration.state == SaveStateTypeEnum.ongoing ||
        bulkConfiguration.state == SaveStateTypeEnum.failed ||
        bulkConfiguration.state == SaveStateTypeEnum.done)
    );
  }

  public getBulkConfigurationTypeName(typeId) {
    return BulkConfigurationType[typeId];
  }

  private initNavActions(): NavAction[] {
    let list: NavAction[] = [];
    if (this._permissionsService.allowed(PermissionsEnum.BulkConfiguration))
      list.unshift({
        icon: "exit_to_app",
        onClick: () => this.onGoBackButtonClick(),
        tooltip: "Return to Admin Center",
      });

    return list;
  }

  private async onGoBackButtonClick() {
    if (!navigator.onLine) {
      this.toastService.showWarnToast(
        $localize`No internet`,
        $localize`Returning to Bulk Configuration.`
      );
      return;
    }

    if (this.canConfigureBulkConfigurations())
      this._router.navigate(["/admin"]);
  }

  private getBulkConfigurations() {
    this._bulkService
      .getBulkConfigurations()
      .pipe(first())
      .subscribe(
        (res) => {
          res.forEach(
            (x) =>
              (x.bulkConfigurationTypeName = this.getBulkConfigurationTypeName(
                x.bulkConfigurationType
              ))
          );
          this.tableValues = res;
          this.globalFilter$.next(this.globalFilter);
        },
        () => this.showErrorWhileGettingBulkConfigurations()
      );
  }

  private showErrorWhileGettingBulkConfigurations() {
    this.toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while retrieving the bulk configurations.`
    );
  }

  private canConfigureBulkConfigurations(): boolean {
    return this._permissionsService.allowed(PermissionsEnum.BulkConfiguration);
  }
}
